import React, { PureComponent } from 'react';
import { FlatList, Scene, View, Tooltip, Link, ActivityIndicator } from 'core';
import Compose from './chat/compose';
import { theme, css } from 'constants';
import * as actions from 'actions';
import renderMsg from './chat/render_msg';
import { IcoDown } from 'icons';

const keyExtractor = item => item.id;

const styles = css({
  indicator: {
    marginVertical: 10
  },
  empty_edge: {
    height: 20
  },
  down_arrow: {
    position: 'absolute',
    bottom: 15,
    right: 10,
    width: 40,
    height: 40,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#FFF',
    borderRadius: 20,
    borderWidth: 1,
    borderColor: theme.gray_color_lighten()
  },
  badge: {
    position: 'absolute',
    top: -15,
    left: -15
  }
});

class Chat extends PureComponent {
  msgs_heights = {};
  msgs_heights_length = 0;
  after_scroll_callbacks = [];

  state = {};

  _resetScrollVars = () => {
    this.msgs_heights = {};
    this.msgs_heights_length = 0;
    this.scrolled_to_unread = false;
    this.after_scroll_callbacks = [];
  };
  componentDidUpdate(pProps) {
    // whyCompUpdated(pProps, this.props);
    if (this.props.conv_id !== pProps.conv_id) {
      !pProps.tmp_pm && actions.sendUnsetWatching({ conv_id: pProps.conv_id, is_group: pProps.is_group, tmp_pm: pProps.tmp_pm });
      !this.props.tmp_pm && actions.sendSetWatching({ conv_id: this.props.conv_id, is_group: this.props.is_group, tmp_pm: this.props.tmp_pm });
      pProps.tmp_pm && actions.removeTmpPM();
      this._resetScrollVars();
    }
  }

  componentWillUnmount() {
    const { conv_id, is_group, tmp_pm } = this.props;
    conv_id && actions.sendUnsetWatching({ conv_id, is_group, tmp_pm });
    this._resetScrollVars();
  }

  componentDidMount() {
    const { conv_id, is_group, tmp_pm } = this.props;
    this.props.conv_id && actions.sendSetWatching({ conv_id, is_group, tmp_pm });
  }
  calculateOffset = (index, height) => {
    const { messages, read_msg } = this.props;
    !this.msgs_heights[index] && this.msgs_heights_length++;
    this.msgs_heights[index] = height;
    if (this.chatHeight && messages.length === this.msgs_heights_length && !this.scrolled_to_unread) {
      const heights = Object.entries(this.msgs_heights);
      const offset = heights.reduce((acc, current) => Number(current[0] > read_msg ? current[1] : 0) + acc, 0);
      offset > this.chatHeight && this._scrollToUnreadMsg(offset - this.chatHeight / 2);
      this.after_scroll_callbacks.forEach(a => a());
      this._resetScrollVars();
      this.scrolled_to_unread = true;
    }
  };

  onLayout = e => (this.chatHeight = e.nativeEvent.layout.height);

  _scrollToUnreadMsg = y => {
    this.chatList.scrollToOffset({ offset: y, animated: true });
  };

  _getPrevMessages = () => {
    const { conv_id, messages } = this.props;
    messages.length > 1 && (this.scrolled_to_unread ? actions.getPrevMessages(conv_id) : this.after_scroll_callbacks.push(() => actions.getPrevMessages(conv_id)));
  };

  _getNextMessages = () => {
    const { conv_id } = this.props;
    this.scrolled_to_unread ? actions.getNextMessages(conv_id) : this.after_scroll_callbacks.push(() => actions.getNextMessages(conv_id));
  };

  _goToPage = pointer => {
    const { conv_id } = this.props;
    const id = pointer || '-L9tWF2AX1L-QPjAAUFc';
    actions.clickGoToMessagesPage(conv_id, id);
  };

  _emptyPageMessages = () => {
    const { conv_id, is_last_msg_reached } = this.props;
    is_last_msg_reached && actions.emptyPageMessages(conv_id);
  };

  _setRef = ref => (this.chatList = ref);

  _onScroll = e => {
    e.nativeEvent.contentOffset.y < 100 ? this.setState({ show_down_arrow: false }) : this.setState({ show_down_arrow: true });
    Tooltip.dismiss();
  };

  _onDownArrowPresses = () => {
    this._emptyPageMessages();
    this.chatList.scrollToOffset({ offset: 0, animated: false });
  };

  renderItem = ({ item, index }) => renderMsg(item, index, this.props, this.calculateOffset);

  render() {
    const { conv_id, messages, is_online, loading_prev, loading_next, is_last_msg_reached, tmp_pm } = this.props;
    return (
      <Scene>
        <Scene>
          {messages.length === 0 && !tmp_pm ? (
            <ActivityIndicator style={{ flex: 1 }} />
          ) : (
            <FlatList
              myRef={this._setRef}
              onLayout={this.onLayout}
              ListHeaderComponent={loading_next ? <ActivityIndicator style={styles.indicator} /> : <View style={styles.empty_edge} />}
              ListFooterComponent={loading_prev ? <ActivityIndicator style={styles.indicator} /> : <View style={styles.empty_edge} />}
              inverted
              data={messages}
              onScroll={this._onScroll}
              keyExtractor={keyExtractor}
              renderItem={this.renderItem}
              onEndReached={this._getPrevMessages}
              onEndReachedThreshold={0.5}
              onStartReached={this._getNextMessages}
              onStartReachedThreshold={0.5}
              scrollAtZero={this._emptyPageMessages}
            />
          )}
          {/* potintial bug */}
          {this.state.show_down_arrow || !is_last_msg_reached ? <Link selected onPress={this._onDownArrowPresses} style={styles.down_arrow} icon={IcoDown} /> : null}
        </Scene>
        <Compose conv_id={conv_id} is_online={is_online} tmp_pm={tmp_pm} />
      </Scene>
    );
  }
}
export default Chat;



// WEBPACK FOOTER //
// ./src/components/middle/chat.js